import React from 'react';
import Card from '../../components/baseUiV3/components/Card';
import { Skeleton } from '../Skeleton';

const CardSkeleton = () => {
  return (
    <Card className={`clr_v3_card__gr`}>
      <Card.Body>
        <Card.Header>
          {/* speciality */}
          <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto">
            <Skeleton variant="text" width={80} height={20} />
          </span>
          {/* share and more */}
          <div className="ms-auto align-items-center d-flex gap-sm-3 gap-2">
            <span className="icon-size-32 icon-size-sm-36 clr_v3_card__icon cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2">
              <Skeleton variant="circular" width={25} height={25} />
            </span>
            <span className="icon-size-32 icon-size-sm-36 clr_v3_card__icon cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2">
              <Skeleton variant="circular" width={25} height={25} />
            </span>
          </div>
        </Card.Header>
        {/* <div className="d-flex"> */}
        <div className="flex-grow-1 d-flex justify-content-center flex-column">
          <Card.Title>
            <Skeleton variant="text" width="90%" height={30} />
          </Card.Title>
          <div className="clr_v3_card__speaker d-flex align-items-center justify-content-between mt-4">
            <div className=" d-flex align-items-center">
              <div className="me-3 d-flex">
                <div className="rounded-circle p-33 border border-primary border-105 bg-white">
                  <div className="clr_v3_userImage overflow-hidden rounded-circle">
                    <Skeleton
                      variant="circular"
                      width={30}
                      height={30}
                      className={`object-fit-cover w-100 h-100`}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-1 text-black">
                <Skeleton variant="text" width={50} height={25} />
                <Skeleton variant="text" width={90} height={20} />
              </div>
            </div>
          </div>
        </div>
        <Card.Image className="mt-4">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
          // className={`object-fit-cover w-100 h-100`}
          />
        </Card.Image>

        {/* </div> */}
        <Card.Footer>
          <div className="me-auto d-flex align-items-center flex-grow-1">
            <span className="clr_v3_card__icon text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center">
              <Skeleton variant="circular" width={25} height={25} />
            </span>
            <span className="clr_v3_card__icon text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center">
              <Skeleton variant="circular" width={25} height={25} />
            </span>
            <span className="clr_v3_card__icon text-dark py-1 d-inline-flex align-items-center justify-content-center">
              <Skeleton variant="circular" width={25} height={25} />
            </span>
          </div>
          <div className="clr_v3_sponsor text-right me-0">
            <div className="clr_v3_sponsor_slide w-100 position-relative">
              <Skeleton variant="rounded" width={100} height={35} />
            </div>
          </div>
        </Card.Footer>
      </Card.Body>
    </Card>
  );
};

export default CardSkeleton;
